import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Context } from 'src/app/context';
import { LanguageModel } from 'src/app/models/language.model';
import { ApiService } from 'src/app/services/api.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
})
export class LanguageSelectionComponent implements OnInit {

  languages$: Observable<LanguageModel[]>;
  selectedLanguage: string;
  hide = false;

  constructor(
    private api: ApiService,
    private languageService: LanguageService
  ) {
  }

  ngOnInit() {
    this.languages$ = this.api.getLanguages().pipe(
      map(x => Array.isArray(x) ? x.filter(language => !!language?.code) : []),
      tap(x => {
        if (x.length === 1) {
          this.selectLanguage(x[0]);
          this.hide = true;
        }
      })
    );
  }

  async selectLanguage(language: LanguageModel) {
    this.selectedLanguage = language.code;
    this.languageService.setLanguage(this.selectedLanguage);

    if (Context.user != null) {
      Context.user.language = language.code;
    }
  }
}
